"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledge.list': '知识库',
    'route.knowledge.create': '添加知识',
    'route.knowledge.edit': '编辑知识',
    'route.knowledge.preview': '知识详情',
    'route.knowledge.bulk_upload': '批量上传知识',
};
